import { useEffect, useRef } from 'react';
import intralysLogo from '@/assets/intralys-fleurdelis.png';

// ═══════════════════════════════════════════════════════════
// IntralysWidget — widget flottant signature agence Intralys
// Reproduction fidèle du widget roynakhal.com (CSS + comportement).
// - État collapsed : cercle 42px avec fleur-de-lis Québec
// - État hover : pill 258px avec stripes + tagline + signature
// - Position : fixed bottom-left, À CÔTÉ du BackToTop (left:78px)
//   (BackToTop Océanne = bottom-6 left-6, 48px → 24-72px occupied)
// - Script : randomize URL vers /ecosysteme, /ecosysteme/{cat}, /technologie
//   + ref=clientId pour tracking attribution
// - Z-index : 40 (sous modals 50+, au-dessus contenu, sous SmsFAB z-50)
// - Texte FR fixe (signature agence — pas bilingue, parité Mathis).
// ═══════════════════════════════════════════════════════════

type Props = {
  /** Slug client pour ref tracking (ex: "oceanne"). */
  clientId: string;
  /** Catégorie écosystème Intralys. */
  category?: 'immobilier' | 'hypothecaire' | 'financier' | 'services' | 'local';
};

export function IntralysWidget({ clientId, category = 'services' }: Props) {
  const linkRef = useRef<HTMLAnchorElement>(null);

  // Script roynakhal : randomize 3 variants URL + append ref=clientId
  useEffect(() => {
    if (!linkRef.current) return;
    const variants = ['/ecosysteme', `/ecosysteme/${category}`, '/technologie'];
    const randomPath = variants[Math.floor(Math.random() * variants.length)];
    linkRef.current.href = `https://intralys.com${randomPath}?ref=${clientId}`;
  }, [clientId, category]);

  return (
    <div className="intralys-widget-container">
      <a
        ref={linkRef}
        target="_blank"
        rel="noopener sponsored"
        className="intralys-widget-link"
        aria-label="Site réalisé par Intralys — Découvrez nos écosystèmes"
        href="https://intralys.com/"
      >
        <img
          src={intralysLogo}
          className="intralys-widget-logo"
          alt="Intralys"
          width={42}
          height={42}
          loading="lazy"
        />
        <div className="intralys-widget-content">
          <div className="intralys-widget-stripes">
            <div className="intralys-widget-stripe intralys-widget-s-orange" />
            <div className="intralys-widget-stripe intralys-widget-s-lblue" />
            <div className="intralys-widget-stripe intralys-widget-s-blue" />
            <div className="intralys-widget-stripe intralys-widget-s-black" />
          </div>
          <div className="intralys-widget-text">
            <span className="intralys-widget-sub">Création fièrement québécoise</span>
            <span className="intralys-widget-title">
              signée Intralys<span className="intralys-widget-dot" />
            </span>
          </div>
        </div>
      </a>
    </div>
  );
}
